Vue.component('ack-product-descriptions-section', {
	delimiters: ['${', '}$'],
	template: '#ack-product-descriptions-section',
	props: {
		isVisible: {
			type: Boolean,
			required: false,
			default: true,
		},
		sectionData: {
			type: Object,
			required: true,
		},
		sectionClass: {
			type: String,
			required: false,
			default: '',
		},
	},
});
